<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.bargains'), $t('text.list')]">
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :sort-config="{ remote: true }"
        :span-method="mergeMethod"
        :loading="loading"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="calculateBgColor"
        size="mini"
        resizable
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isMerge">
              <thumbnail :images="row.images" />
            </span>
            <div v-else>
              <span v-if="row.type == 'clean'">
                {{ row.serialNo }}
                <span class="font10 mgr5" v-if="row.serviceName != null">
                  {{ $t("rent.serviceName") }}:{{ row.serviceName }}
                </span>
                <span class="font10 mgr5" v-if="row.serviceAmount != null">
                  {{ $t("rent.serviceAmount") }}:{{
                    row.serviceAmount | currency
                  }}
                </span>

                <span class="float-right font10">
                  {{ $t("text.owner") }}:{{ row.ownerName }} {{ row.shopName }}
                </span>
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('rentItem.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div>
              <state-label
                :state="row.workflowState"
                v-if="['rent', 'clean', 'service'].includes(row.type)"
              >
                {{ $t("rentStates." + row.workflowState) }}
              </state-label>
              <state-label :state="row.workflowState" v-else>
                {{ $t("orderStates." + row.workflowState) }}
              </state-label>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">
              {{ row.categoryName }}<span v-if="row.brand !== null">/</span
              >{{ row.brand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="endAt"
          :title="$t('clean.rentAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span v-if="['rent', 'clean', 'service'].includes(row.type)">
              <div class="font10">{{ row.startAt }}</div>
              <div class="font10">{{ row.endAt }}</div>
            </span>
            <span>{{ row.handOverAt }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="outName"
          :title="$t('rentItem.outName')"
          min-width="96"
        >
          <template v-slot="{ row }">
            {{ row.outName }}
            <div class="font10">{{ row.outAt }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="finishName"
          :title="$t('rentItem.finishName')"
          min-width="96"
        >
          <template v-slot="{ row }">
            {{ row.finishName }}
            <div class="font10">{{ row.finishAt }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span> 条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { table, page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";
import Dropzone from "@/components/Dropzone";
import ThumbnailText from "@/components/ThumbnailText";
//
import Workbench from "@/api/workbench.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    RawHtmlLimitNumber,
    RawHtml,
    Dropzone,
    ThumbnailText,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "rent_id",
        sortIndicator: "desc",
      },
      shops: [],
      //
      row: null,
      currentRowIdx: null,
      currentRowRentId: null,
      currentRowItemId: null,
    };
  },
  created() {
    const self = this;
  },
  methods: {
    //
    dataProvider(params) {
      params["createAtStartAt"] = this.$route.query.createAtStartAt;
      params["createAtEndAt"] = this.$route.query.createAtEndAt;
      params["shopId"] = this.$route.query.shopId;
      if (
        this.$route.query &&
        this.$route.query.serviceName != null &&
        this.$route.query.serviceName != ""
      ) {
        params["serviceName"] = this.$route.query.serviceName;
      }

      return Workbench.cleanStatisticsDetail(params);
    },
    recordsDecorate(records) {
      this.records = this.buildTableData(records);
      this.mergeCells = this.buildMergeCells(records);
    },
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bRent = {
          isMerge: true,
          id: record.id,
          serialNo: record.serialNo,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          remark: record.remark,
          cancelAt: record.cancelAt,
          cancelReason: record.cancelReason,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          shopId: record.shopId,
          shopName: record.shopName,
          createAt: record.createAt,
          tenantId: record.tenantId,
          startAt: record.startAt,
          endAt: record.endAt,
          customerSource: record.customerSource,
          amount: record.amount,
          payAmount: record.payAmount,
          diffAmount: record.diffAmount,
          items: record.items,
          payments: record.payments,
          type: record.type,
          packageId: record.packageId,
          packageName: record.packageName,
          packageAmount: record.packageAmount,
          scheduleId: record.scheduleId,
          deposit: record.deposit,
          depositAmount: record.depositAmount,
          depositReturnAmount: record.depositReturnAmount,
          serviceName: record.serviceName,
          serviceAmount: record.serviceAmount,
          items: record.items,
          orders: record.orders,
        };
        rs.push(bRent); //将bargain的数据转换到格式，放到数据列表
        record.items.forEach((item) => {
          rs.push(item);
        });
      });
      return rs;
    },
    buildMergeCells(rents) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < rents.length; i++) {
        mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 9 });
        rowIdx = rowIdx + rents[i].items.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMerge ? "light-blue-bg" : "";
    },
  },
};
</script>
<style scoped>
</style>